import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useLightbox } from '../../context/LightboxContext';
import {
    BUSINESS_ADDRESS_SINGLE,
    BUSINESS_HOURS,
    BUSINESS_WHATSAPP_CHAT_URL,
    BUSINESS_MAP_URL,
} from '../../config/businessInfo';
import './HelpCtaSection.css';

const SUPPORT_IMG = 'assets/media/images/team/employee_presenting_refrigerator.jpg';

const HelpCtaSection = () => {
    const { openLightbox } = useLightbox();

    return (
        <section className="help-cta-section" aria-label="Customer help and showroom contact">
            <div className="container">
                <div className="help-cta-card">
                    <div className="help-cta-content">
                        <span className="section-eyebrow help-cta-eyebrow">CUSTOMER CARE &amp; CONSULTATION</span>
                        <h2 className="help-cta-title">
                            Need Advice on an Appliance or Installment Plan?
                        </h2>
                        <p className="help-cta-desc">
                            Our Lahore showroom team is available Monday to Saturday to guide you on product specifications, genuine brand warranties, and fast 24-hour installment approvals.
                        </p>

                        <div className="help-cta-actions">
                            <Link to="/contact" className="btn help-btn help-btn-contact">
                                <FiMail aria-hidden="true" /> Contact Our Team
                            </Link>
                            <a
                                href={BUSINESS_WHATSAPP_CHAT_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn help-btn help-btn-wa"
                                aria-label="Chat with Rahber Corporation on WhatsApp"
                            >
                                <FaWhatsapp aria-hidden="true" /> WhatsApp Chat
                            </a>
                        </div>
                    </div>

                    {/* Right Consultation Showcase with Real Showroom Support Photo */}
                    <div className="help-cta-media-wrap">
                        <div
                            className="help-cta-photo-frame zoomable-image"
                            onClick={() => openLightbox(SUPPORT_IMG, 'In-person customer consultation at Rahber Corporation showroom', 'Lahore Showroom Customer Care & Consultation')}
                            title="Click to view full photo"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    openLightbox(SUPPORT_IMG, 'In-person customer consultation at Rahber Corporation showroom', 'Lahore Showroom Customer Care & Consultation');
                                }
                            }}
                        >
                            <img
                                src={SUPPORT_IMG}
                                alt="In-person customer consultation at Rahber Corporation showroom"
                                className="help-cta-photo"
                                loading="lazy"
                            />
                            <div className="help-cta-photo-overlay" />
                        </div>
                        <div className="help-cta-info-box">
                            <h3 className="help-info-title">Visit Lahore Showroom</h3>
                            <ul className="help-info-list">
                                <li>
                                    <FiMapPin className="help-info-icon" aria-hidden="true" />
                                    <span>{BUSINESS_ADDRESS_SINGLE}</span>
                                </li>
                                <li>
                                    <FiClock className="help-info-icon" aria-hidden="true" />
                                    <span>{BUSINESS_HOURS.lines[0]}</span>
                                </li>
                            </ul>
                            <a
                                href={BUSINESS_MAP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="help-info-link"
                            >
                                Open on Google Maps →
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HelpCtaSection;
